import React, { memo } from 'react';
import classNames from 'classnames';

import NextImage from '@com/_core/NextImage';
import Badge from '@com/shared/badge';
import Counter from '../../shared/counter';
import BadgeLabel from '@com/shared/cards/badgeLabel';
import { ShopProductsItemModel } from '@models/shop';
import Divider from '@com/_atoms/Divider';
import Chips from '@com/shared/Chips';
import { convertRialToTomanNumber } from '@utilities/mainUtils';

interface ShopPlpVerticalCardProps {
  onClickHandler: (e: any) => void;
  product: ShopProductsItemModel;
  hasAddToCart?: boolean;
  className?: string;
  imagePriority?: boolean;
}

const ShopPlpVerticalCard = memo(
  ({
    onClickHandler,
    product,
    hasAddToCart,
    className,
    imagePriority = false,
  }: ShopPlpVerticalCardProps) => {
    return (
      <div
        onClick={onClickHandler}
        className={classNames(
          className,
          'relative m-auto h-[283px] w-full flex flex-col gap-y-2 bg-surface-primary rounded-xl px-2 py-2 shadow-practicalTop cursor-pointer',
        )}
      >
        {product?.isRare && (
          <BadgeLabel
            text="داروی‌کمیاب"
            iconName="Spark"
            className="top-2 right-2 z-10"
          />
        )}
        <div className="h-28 m-auto bg-white rounded-lg flex justify-center items-center relative max-w-[112px]">
          <NextImage
            src={product?.imageLink}
            alt="vertical-1"
            width={112}
            height={112}
            priority={imagePriority}
          />
          {hasAddToCart && <Counter product={product} />}
        </div>
        <div className="flex flex-col">
          {product?.productName && (
            <div className="mt-2 text-xs md:min-h-[36px]">
              <p className="line-clamp-2">{product?.productName}</p>
            </div>
          )}
          <div className="mt-auto">
            {product.shapeName && (
              <div className="mt-2 text-xs overflow-x-auto flex">
                <Badge color="blue" className="h-[22px]">
                  {product?.shapeName}
                </Badge>
              </div>
            )}
            {!!product?.slangs?.length && (
              <div className="h-[22px] mt-2 text-xs w-full flex overflow-x-auto">
                {product?.slangs?.map((item, index) => (
                  <Badge key={index} color="gray" className="h-[22px]">
                    {item}
                  </Badge>
                ))}
              </div>
            )}
          </div>

          <Divider className="h-[1px] mt-2" padding={0} />

          <div
            className={classNames(
              'w-full pt-2 flex gap-x-1',
              !!product?.discountPercentage || !!product?.discountPercent
                ? 'justify-between'
                : 'justify-end',
            )}
          >
            {(!!product?.discountPercentage || !!product?.discountPercent) && (
              <Chips
                text={`٪ ${product?.discountPercentage ?? product?.discountPercent}`}
                className="w-max h-6 px-2 bg-surface-warning text-content-primary text-Label/xSmall "
              />
            )}

            <div className="flex flex-col items-end">
              <div className="flex items-center gap-x-1">
                <span className="text-content-primary text-Label/Medium">
                  {!!product?.discountPercentage || !!product?.discountPercent
                    ? convertRialToTomanNumber(
                        product?.discount ?? product?.discountPrice,
                      ).toLocaleString('fa-IR')
                    : convertRialToTomanNumber(product?.price).toLocaleString(
                        'fa-IR',
                      )}
                </span>
                <span className="text-Label/xSmall text-content-primary">
                  تومان
                </span>
              </div>

              {(!!product?.discountPercentage ||
                !!product?.discountPercent) && (
                <div className="flex items-center gap-x-1">
                  <span className="text-content-tertiary text-Label/Medium line-through">
                    {convertRialToTomanNumber(product?.price).toLocaleString(
                      'fa-IR',
                    )}
                  </span>
                  <span className="text-Label/xSmall text-content-tertiary">
                    تومان
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  },
);
export default ShopPlpVerticalCard;
